import { LocalStorage } from "quasar";
import useData from "src/use/data";
import useDataV2 from "src/use/datav2";
import useUtils from "src/use/utils.js";

const { getAllSectors } = useUtils();

var intervalIds = [];
var indexes = getAllSectors();

const stopStreaming = () => {
  intervalIds.forEach((_id) => clearInterval(_id));
  LocalStorage.setItem("isMarketOn", false);
  intervalIds = [];
};

const clearOldIntervals = () => {
  let limit = 1;
  if (
    window.location.pathname.split("/")[1] == "two-charts-layout" ||
    window.location.pathname.split("/")[1] == "three-charts-layout" ||
    window.location.pathname.split("/")[1] == "four-charts-layout" ||
    window.location.pathname.split("/")[1] == "five-charts-layout" ||
    window.location.pathname.split("/")[1] == "six-charts-layout"
  )
    limit = 24;
  if (intervalIds.length >= limit) {
    const oldIds = intervalIds.splice(0, intervalIds.length - limit);
    oldIds.forEach((_id) => clearInterval(_id));
  }
};
export function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  lastDailyBar
) {
  const { intraHistoryDataSearchLive, historyDataSearch } = useData();
  const { LiveMarketDataIntraday } = useDataV2();
  var lastBar = lastDailyBar;
  let id;
  let streamingIntervalInsecond = 40;
  let isIndex = indexes.find((i) => i.symbol === symbolInfo.full_name);

  if (isIndex) {
    streamingIntervalInsecond = 40;
  } else {
    if (resolution == "1") {
      streamingIntervalInsecond = 10;
    } else {
      streamingIntervalInsecond = 40;
    }
  }
  if (LocalStorage.getItem("isMarketOn")) {
    let days = 1;
    let count = 0;
    id = setInterval(() => {
      if (resolution == "1D") {
        apiCall();
        function apiCall() {
          count += 1;
          let toDate = LocalStorage.getItem("as_of_live_unix");
          historyDataSearch(
            symbolInfo.full_name,
            Math.floor(toDate) - 86400 * days,
            Math.floor(toDate),
            true
          ).then((res) => {
            if (res.headers?.["x-stream"] === "0") {
              stopStreaming();
              return;
            }
            if (res.data.length == 0) {
              // Fall Back Condition for longer holidays.
              if (count == 4 && res.data.length == 0) return;
              days = 15;
              apiCall();
            }
            const dateStr = res?.data?.[0]?.["date"];
            const tradeTime = dateStr ? new Date(dateStr).getTime() : null;
            const nextDailyBarTime = getNextDailyBarTime(lastBar?.time);
            let bar = {
              high: res.data?.[0]?.high ?? null,
              low: res.data?.[0]?.low ?? null,
              open: res.data?.[0]?.open ?? null,
              time: tradeTime,
              close: res.data?.[0]?.close ?? null,
              volume:
                symbolInfo.type === "index"
                  ? parseFloat(res.data?.[0]?.amount ?? null)
                  : parseFloat(res.data?.[0]?.volume) ?? null,
            };

            if (tradeTime >= nextDailyBarTime) {
              lastBar = bar;
            }
            onRealtimeCallback(bar);
          });
        }
      } else {
        apiCall();
        async function apiCall() {
          let res;
          if (!!symbolInfo.full_name == false) return;
          if (isIndex) {
            res = await intraHistoryDataSearchLive(symbolInfo.full_name);
            if (res.headers?.["x-stream"] === "0") {
              stopStreaming();
              return;
            }
            if (res.data) {
              let timestamp = res.data.t?.[0] ? res.data.t[0] * 1000 : null;
              const nextDailyBarTime = getNextDailyBarTime(lastBar.time);
              let bar = {
                high: res.data.h?.[0] ?? null,
                low: res.data.l?.[0] ?? null,
                open: res.data.o?.[0] ?? null,
                time: timestamp,
                close: res.data.c?.[0] ?? null,
                volume:
                  symbolInfo.type === "index"
                    ? parseFloat(res.data.ca?.[0]) ?? null
                    : parseFloat(res.data.cv?.[0]) ?? null,
              };

              if (timestamp >= nextDailyBarTime) {
                lastBar = bar;
              }
              onRealtimeCallback(bar);
            }
          } else {
            res = await LiveMarketDataIntraday(symbolInfo.full_name);
            if (res.headers["x-stream"] === "0") {
              stopStreaming();
              return;
            }
            if (res.data) {
              const nextDailyBarTime = getNextDailyBarTime(lastBar.time);
              let timestamp = res.data?.[0]["timestamp"] * 1000 ?? null;
              let bar = {
                high: res.data?.[0].curr_high ?? null,
                low: res.data?.[0].curr_low ?? null,
                open: res.data?.[0].p_ltp ?? null,
                time: timestamp,
                close: res.data?.[0].ltp ?? null,
                volume:
                  symbolInfo.type === "index"
                    ? parseFloat(res.data?.[0].amount ?? null)
                    : parseFloat(res.data?.[0]?.ltv) ?? null,
              };

              if (timestamp >= nextDailyBarTime) {
                lastBar = bar;
              }
              onRealtimeCallback(bar);
            }
          }
        }
      }
    }, 1000 * streamingIntervalInsecond);

    intervalIds.push(id);
    clearOldIntervals();

    function getNextDailyBarTime(barTime) {
      const date = new Date(barTime * 1000);
      date.setDate(date.getDate() + 1);
      return date.getTime() / 1000;
    }
  }
}
